import React, { useState, useEffect, useMemo, useRef } from 'react';
import {
  Container,
  Input,
  Button,
  Row,
  Col,
  Modal,
  ModalHeader,
  ModalBody,
} from 'reactstrap';
import { connect } from 'react-redux';
import { INotificationTable, ITarget } from '../../types/interfaces';
import { getNotificationImage } from '../../flux/actions/notificationmodelActions';

// import NotificationEdit from './NotificationEdit';
import NotificationDelete from './NotificationDelete';
import TableContainer from "../tables_manager/TableContainer"
import { DateRangeColumnFilter, SelectColumnFilter } from '../tables_manager/filters';
import EditableCell from "../tables_manager/EditableCell";
import Select from 'react-select';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faCheckCircle, faClipboard, faExternalLinkAlt, faEye, faEyeSlash, faIdCard, faImage, faList, faPen, faPhone, faPrint, faTimesCircle, faTrash, faUsers } from '@fortawesome/free-solid-svg-icons'
import { useHistory } from 'react-router-dom';
import axios from 'axios';
import { E_ERROR } from '../../types/errors';
import { useAlert } from "react-alert";
import moment from "moment";
import Loading from '../Loading';
import ReactTooltip from 'react-tooltip';
import { constants } from '../../types/constants';

const NotificationTable = ({ 
  linesData,
  setTableData,
 }: INotificationTable) => {
  const [modal, setModal] = useState(false);
  const [modalDelete, setModalDelete] = useState(false);
  const [modalScan, setModalScan] = useState(false);
  const [modalUsers, setModalUsers] = useState(false);
  const [modalNotification, setModalNotification] = useState('');
  const [modalDeleteNotification, setModalDeleteNotification] = useState('');
  const [modalImageNotification, setModalImageNotification] = useState('');
  const [modalUsersNotification, setModalUsersNotification] = useState<any[]>([]);
  const [notificationImg, setNotificationImg] = useState('');
  const [imageLoading, setimageLoading] = useState(false);
  const [imagesCache, setImagesCache] = useState<any[]>([]);
  const history = useHistory();

  const alert = useAlert();
  
  const handleToggle = () => setModal(!modal);
  const handleToggleDelete = () => setModalDelete(!modalDelete);
  const handleToggleScan = () => setModalScan(!modalScan);
  const handleToggleUsers = () => setModalUsers(!modalUsers);

  const modalOpenedHandleScan = async () => {
    if(modalImageNotification && modalImageNotification !== ''){
      const cachednotificationImg = imagesCache.find(e => e.id === modalImageNotification["id"]);
      if(!!cachednotificationImg)
        setNotificationImg(cachednotificationImg.image ? ("data:image/jpeg;base64," + cachednotificationImg.image) : "")
      else{
        setimageLoading(true);
        const imageRes = await getNotificationImage(modalImageNotification["id"]);
        setimageLoading(false);
        setNotificationImg(imageRes?.data ? ("data:image/jpeg;base64," + imageRes?.data) : "");
        setImagesCache(e => [...e, {id: modalImageNotification["id"], image: imageRes?.data || ''}]);
      }
    }
    else{
      setNotificationImg("");
    }
  };

  const modalClosedHandleScan = () => {
    setModalImageNotification('');
    setNotificationImg('');
  };

  const columns = useMemo(
    () => [
      {
        Header: "ID",
        accessor: "id",
        hidden: true
      },
      {
        Header: "Type",
        // accessor: (row, index) => row.type === constants.NOTIFICATION_TYPE_INFO.value ? constants.NOTIFICATION_TYPE_INFO.label : row.type === constants.NOTIFICATION_TYPE_WARNING.value ? constants.NOTIFICATION_TYPE_WARNING.label : "",
        accessor: e => constants.NOTIFICATION_TYPES.find(t => t.code === e.type)?.label || "",
        Filter: SelectColumnFilter,
        filter: 'equals',
        Cell: ({ value, row: {original} }) => {
          const notificationTypeData = constants.NOTIFICATION_TYPES.find(e => e.code === original.type)
          if(!notificationTypeData)
            return value || "-"
          return <div style={{display: "flex", alignItems: "center", whiteSpace: 'nowrap'}}><FontAwesomeIcon icon={notificationTypeData.icon} style={{color: notificationTypeData.color, marginRight: "4px", fontSize: "medium"}} />{value}</div>
        }
        // className: "text-center",
        // Cell: ({ row: {original} }) => original.on_computer === 1 ? <FontAwesomeIcon icon={faLaptop} title="Ordinateur" style={{fontSize: "x-large"}} /> : original.on_computer === 0 ? <FontAwesomeIcon icon={faMobileAlt} title="Téléphone" style={{fontSize: "x-large"}} /> : "-",
      },
      {
        Header: "Titre",
        accessor: "title",
        Cell: ({ value }) => value || "-"
      },
      {
        Header: "Déscription",
        accessor: "description",
        Cell: ({ value }) => <div className="maxLines max3Lines">{value || "-"}</div>
      },
      {
        Header: "Valide de",
        accessor: "validFrom",
        customExportDisplay: `$.validFrom ? new Date($.validFrom) : "-"`,
        Filter: DateRangeColumnFilter,
        filter: "dateBetween",
        Cell: ({ value }) => value ? <div style={{color: moment(value).isBefore(moment(), 'day') ? "black" : "darkred"}}>{moment(value).format('DD/MM/YYYY')}</div> : "-",
      },
      {
        Header: "Fin de validité",
        accessor: "validTo",
        customExportDisplay: `$.validTo ? new Date($.validTo) : "-"`,
        Filter: DateRangeColumnFilter,
        filter: "dateBetween",
        Cell: ({ value }) => value ? <div style={{color: moment(value).isAfter(moment(), 'day') ? "black" : "darkred"}}>{moment(value).format('DD/MM/YYYY')}</div> : "-",
      },
      {
        Header: "Destinataires cachés",
        accessor: e => e.hideReceivers === 1 ? "Oui" : e.hideReceivers === 0 ? "Non" : "",
        Filter: SelectColumnFilter,
        filter: 'equals',
        className: "text-center",
        Cell: ({ value }) => value || "-"
      },
      {
        Header: "Privée",
        accessor: e => e.private === 1 ? "Oui" : e.private === 0 ? "Non" : "",
        Filter: SelectColumnFilter,
        filter: 'equals',
        className: "text-center",
        Cell: ({ value }) => value || "-"
      },
      // {
      //   Header: "Activée",
      //   accessor: (row, index) => row.enabled === 1 ? "Oui" : row.enabled === 0 ? "Non" : "",
      //   Filter: SelectColumnFilter,
      //   filter: 'equals',
      //   className: "text-center",
      //   Cell: ({ row: {original} }) => original.enabled === 1 ? <FontAwesomeIcon icon={faCheckCircle} style={{color: "darkgreen", fontSize: "x-large"}} /> : original.enabled === 0 ? <FontAwesomeIcon icon={faTimesCircle} style={{color: "red", fontSize: "x-large"}} /> : "-",
      // },
      {
        Header: "Créée par",
        accessor: e => e.user?.LOGIN || "",
        Cell: ({ value }) => value || "-",
        hidden: true
      },
      {
        Header: "Créée le",
        accessor: "createdAt",
        customExportDisplay: `$.createdAt ? new Date($.createdAt).toLocaleString('fr') : ""`,
        Filter: DateRangeColumnFilter,
        filter: "dateBetween",
        Cell: ({ value }) => value ? <div title={moment(value).format('DD/MM/YYYY - HH:mm')}>{moment(value).locale('fr').calendar({
            sameDay: '[Aujourd\'hui à] HH:mm',
            nextDay: 'DD/MM/YYYY à HH:mm',
            nextWeek: 'DD/MM/YYYY à HH:mm',
            lastDay: '[Hier à] HH:mm',
            lastWeek: 'DD/MM/YYYY à HH:mm',
            sameElse: 'DD/MM/YYYY à HH:mm'
        })}</div> : "-",
      },
      {
        Header: "Commentaire",
        accessor: "comment",
        Cell: ({ value }) => value || "-",
        hidden: true
      },
      {
        Header: "Action",
        className: "text-center",
        Cell: ({ row: {original} }) => (
            <Container className="actionsContainer">
              <button className="btn btn-success btn-rounded btn-sm my-0 waves-effect waves-light"
                onClick={() => {setModalNotification(original); setModal(true)}}
                disabled
                title="Modifier">
                <FontAwesomeIcon icon={faPen} />
              </button>
              <button className="btn btn-danger btn-rounded btn-sm my-0 waves-effect waves-light actionButtonsSpace"
                onClick={() => {setModalDeleteNotification(original); setModalDelete(true)}}
                title="Supprimer">
                <FontAwesomeIcon icon={faTrash} />
              </button>
              <button className="btn btn-warning btn-rounded btn-sm my-0 waves-effect waves-light actionButtonsSpace"
                onClick={() => (setModalUsersNotification(original.notifications || []), setModalUsers(true))}
                title="Destinataires">
                <FontAwesomeIcon icon={faUsers} />
              </button>
              <button className="btn btn-info btn-rounded btn-sm my-0 waves-effect waves-light actionButtonsSpace"
                onClick={() => (setModalImageNotification(original), setModalScan(true))}
                disabled={!original.hasImage}
                title={!original.hasImage ? "Aucune image jointe" : "Aperçu de l'image"}>
                <FontAwesomeIcon icon={faImage} />
              </button>
            </Container>
        ),
        disableSortBy: true,
     }
    ],
    []
  );

  return (
    <div>
      <TableContainer columns={columns} data={linesData} enableCheckBox={false} isEditable={false} SubComponent={({ row }) => <span>SubComponent: {row.id}</span>}/>
      {/* <NotificationEdit modal={modal} setModal={setModal} handleToggle={handleToggle} modalNotification={modalNotification} /> */}
      <NotificationDelete modal={modalDelete} setModal={setModalDelete} handleToggle={handleToggleDelete} modalNotification={modalDeleteNotification} />

      <Modal isOpen={modalScan} toggle={handleToggleScan} onOpened={modalOpenedHandleScan} onClosed={modalClosedHandleScan} className="modal-dialog-large">
        <ModalHeader toggle={handleToggleScan}><FontAwesomeIcon icon={faImage} />&nbsp;&nbsp;Image</ModalHeader>
        <ModalBody>
          <Container className="scanPreviewContainer">
            {notificationImg || imageLoading ? <Row>
              <Col xs="12">{imageLoading ? <Loading /> : <img className="scanPreview" src={notificationImg}/>}</Col>
            </Row> : null}
          </Container>
        </ModalBody>
      </Modal>

      <Modal isOpen={modalUsers} toggle={handleToggleUsers}>
        <ModalHeader toggle={handleToggleUsers}><FontAwesomeIcon icon={faUsers} />&nbsp;&nbsp;Destinataires</ModalHeader>
        <ModalBody>
          <Container>
            {/* {modalUsersNotification.map((e, key) => <Row key={key}>
              <Col xs="6" className="text-right">{e.user?.LOGIN || "-"}</Col>
              <Col xs="6"><FontAwesomeIcon icon={e.seenAt ? faEye : faEyeSlash} style={{color: e.seenAt ? "green" : "orangered"}} />{e.seenAt ? e.seenAt ? ` ${moment(e.seenAt).locale('fr').calendar({
                  sameDay: '[Aujourd\'hui à] HH:mm',
                  nextDay: 'DD/MM/YYYY à HH:mm',
                  nextWeek: 'DD/MM/YYYY à HH:mm',
                  lastDay: '[Hier à] HH:mm',
                  lastWeek: 'DD/MM/YYYY à HH:mm',
                  sameElse: 'DD/MM/YYYY à HH:mm'
              })}` : " -" : ""}</Col>
            </Row>)} */}
            <TableContainer columns={[
                {
                  Header: "Nom",
                  accessor: e => e.user?.LOGIN || ""
                },
                {
                  Header: "Vu",
                  accessor: e => e.seenAt ? "Oui" : "Non",
                  Filter: SelectColumnFilter,
                  filter: 'equals',
                  className: "text-center",
                  Cell: ({row: {original}}) => <FontAwesomeIcon icon={original.seenAt ? faEye : faEyeSlash} style={{color: original.seenAt ? "green" : "orangered"}} />
                },
                {
                  Header: "Vu le",
                  accessor: "seenAt",
                  Filter: DateRangeColumnFilter,
                  filter: "dateBetween",
                  Cell: ({value}) => value ? moment(value).locale('fr').calendar({
                      sameDay: '[Aujourd\'hui à] HH:mm',
                      nextDay: 'DD/MM/YYYY à HH:mm',
                      nextWeek: 'DD/MM/YYYY à HH:mm',
                      lastDay: '[Hier à] HH:mm',
                      lastWeek: 'DD/MM/YYYY à HH:mm',
                      sameElse: 'DD/MM/YYYY à HH:mm'
                    }) : "-"
                },
              ]} data={modalUsersNotification} enableCheckBox={false} smallerCols bgColor="cornflowerblue" showPagination={false} />
          </Container>
        </ModalBody>
      </Modal>
    </div>
  );
};

// const mapStateToProps = (state: INotificationTableRedux) => ({
// });

export default connect(null, {})(NotificationTable);
